import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/profile/entity',
    name: ROUTES.PROFILE_ENTITY,
    component: () => import('../views/profile/ProfileEntityInfo'),
  },
  {
    path: '/:accountId/profile/general-info',
    name: ROUTES.PROFILE_GENERAL,
    component: () => import('../views/profile/ProfileGeneralInfo'),
  },
  {
    path: '/:accountId/profile/safety',
    name: ROUTES.PROFILE_SAFETY,
    component: () => import('../views/profile/ProfileSafety'),
  },
  {
    path: '/:accountId/profile/named-insureds',
    name: ROUTES.PROFILE_NAMED_INSUREDS,
    component: () => import('../views/profile/ProfileNamedInsureds'),
  },
  {
    path: '/:accountId/profile/files',
    name: ROUTES.PROFILE_SUPPORTING_FILES,
    component: () => import('../views/profile/ProfileFiles'),
  },
  {
    path: '/:accountId/profile/industry',
    name: ROUTES.PROFILE_INDUSTRY,
    component: () => import('../views/profile/ProfileIndustryQuestions'),
  },
]
